import { Loader, TextInput, Tooltip } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { When } from '../components/control-flow/When';
import { Wrap } from '../components/control-flow/Wrap';
import { isFunction } from '../utils/utilFunctions';

export const QueryBaseComponent = <T,>({
    name,
    query: { status, data, error, isEnabled },
    NullQueryContent,
    children,
    skeleton,
    disabledContent,
}: {
    name: string; // TODO Capitalize<string>;
    query: UseQueryResult<T>;
    NullQueryContent?: ReactNode;
    children: ReactNode | ((data: NonNullable<T>) => ReactNode);
    skeleton?: ReactNode;
    disabledContent?: ReactNode;
}) => {
    if (!isEnabled && disabledContent) {
        return disabledContent;
    }

    return (
        <When
            expression={status}
            cases={{
                pending: skeleton ?? (
                    <TextInput
                        w={'100%'}
                        leftSection={<Loader size="sm" />}
                        value={`Fetching ${name}…`}
                        readOnly
                    />
                ),
                error: (
                    <TextInput
                        w={'100%'}
                        leftSection={
                            <Wrap
                                With={Tooltip}
                                when={error?.message}
                                props={{
                                    multiline: true,
                                    label: error?.message,
                                }}
                            >
                                <IconExclamationCircle color={'red'} />
                            </Wrap>
                        }
                        value={`Error! ${name} could not be fetched!`}
                        readOnly
                    />
                ),
                success:
                    data ?
                        isFunction(children) ? children(data)
                        :   children
                    :   NullQueryContent,
            }}
        />
    );
};
